import { AppAction } from "../../../root/AppAction";
import UserEvents from "../../../user/UserEvents";
import { ExportVideoInfo, UpdateVideoInfo } from "../../models/video";
import TimelineEvents from "../events/TimelineEvents";
import VideoInfoEvents from "../events/VideoInfoEvents";

/**
 * スタジオの動画編集画面の各種情報
 */

export interface VideoInfoStore {
    updateVideoInfo: UpdateVideoInfo;
    exportVideoInfo: ExportVideoInfo;
    isLoading: boolean;
    isSuccessExportVideo: boolean;
}

const initialVideoInfoStore: VideoInfoStore = {
    updateVideoInfo: {
        id: -1,
        bitrate: 1000000,
        width: 1280,
        height: 720,
        framerate: 30,
        denoise: false,
        opTemplateId: -1,
        edTemplateId: -1,
        userId: -1
    },
    exportVideoInfo: {
        id: -1,
        bitrate: 1000000,
        width: 1280,
        height: 720,
        framerate: 30,
        denoise: false,
        status: "",
        opTemplateId: -1,
        edTemplateId: -1
    },
    isLoading: false,
    isSuccessExportVideo: false
};

export function videoInfo(state: VideoInfoStore = initialVideoInfoStore, action: AppAction) {
    switch (action.type) {
        case VideoInfoEvents.UpdateVideoInfoStarted:
            return {
                ...state,
                isLoading: true,
                isSuccessExportVideo: false,
            };

        case VideoInfoEvents.UpdateVideoInfoComplete:
            return {
                ...state,
                exportVideoInfo: action.exportVideoInfo,
                isLoading: false,
                isSuccessExportVideo: true,
            };

        case VideoInfoEvents.UpdateExportVideoInfo:
            return {
                ...state,
                exportVideoInfo: action.exportVideoInfo,
                updateVideoInfo: {
                    ...action.exportVideoInfo,
                    status: undefined,
                    userId: state.updateVideoInfo.userId
                }
            };

        case TimelineEvents.GetTimelineComplete:
            return {
                ...state,
                exportVideoInfo: {
                    ...state.exportVideoInfo,
                    id: action.result.timeline.id,
                    status: action.result.timeline.status
                    // BEに返り値exportSettingsパラメータを追加してもらう予定
                    // opTemplateId: action.result.timeline.exportSettings.opTemplateId,
                    // edTemplateId: action.result.timeline.exportSettings.edTemplateId
                },
                updateVideoInfo: {
                    ...state.updateVideoInfo,
                    id: action.result.timeline.id
                }
            };
            
        case UserEvents.LoginComplete:
            return {
                ...state,
                updateVideoInfo: {
                    ...state.updateVideoInfo,
                    userId: action.user.id
                }
            };

        default:
            return state;
    }
}
